import * as craft from './craft.js'
import * as home from './home.js'
import * as navigation from './navigation.js'
import * as footer from './footer.js'
import * as vinoPage from './vino-page.js'
import * as birraPage from './birra-page.js'
import * as product from './product.js'
import * as agricoltura from './agricoltura.js'
import * as panificati from './panificati.js'
import * as nutraceutica from './nutraceutica.js'
import * as contatti from './contatti.js'
import * as azienda from './azienda.js'
import * as sitemap from './sitemap.js'
import * as percheNoi from './perche-noi.js'
import * as servizi from './servizi.js'
import * as risorse from './risorse.js'
import * as news from './news-page.js'
import * as archivioNews from './archivio-news.js'
import * as newsItem from './news-item.js'
import * as comeFarePer from './come-fare-per.js'
import * as modalitaDuso from './modalita-d-uso.js'
import * as copyright from './copyright'

export default {
  craft,
  home,
  navigation,
  footer,
  vinoPage,
  birraPage,
  product,
  agricoltura,
  panificati,
  nutraceutica,
  contatti,
  azienda,
  sitemap,
  percheNoi,
  servizi,
  risorse,
  news,
  archivioNews,
  newsItem,
  comeFarePer,
  modalitaDuso,
  copyright,
}
